import { ShopFilter } from "@b2bportal/air-shopping-api";
import type {
  NewPackagesSearch,
  PackagesSearch,
} from "@/store/packages/slice/packagesSearch";
import { buildPackageFlightShopPassengers } from "@/store/packages/thunks/flightPassengerUtils";

export const createFlightSearch = (
  search: PackagesSearch | NewPackagesSearch
) => {
  return {
    route: {
      origin: search.origin.airportCode.code,
      destination: search.destination.airportCode.code,
    },
    departureDate: search.dateRange.from,
    returnDate: search.dateRange.until,
    passengers: buildPackageFlightShopPassengers(search.guests),
    tripFilter: ShopFilter.NoFilter,
    fareClass: [],
  };
};
